// extracted by mini-css-extract-plugin
export default {"wrapper":"UserCard_wrapper__PApDp","name":"UserCard_name__aEvsw"};